// PageHeader — encabezado consistente de cada página (eyebrow + título + descripción + acciones).
// Reemplaza el patrón copy-paste que tenía cada feature.
import type { ReactNode } from "react";

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
}: {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-enter mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="space-y-1.5">
        {eyebrow && (
          <div className="font-[var(--font-mono)] text-[10px] font-semibold uppercase tracking-widest text-[var(--color-text-muted)]">
            {eyebrow}
          </div>
        )}
        <h1 className="font-[var(--font-display)] text-[clamp(1.75rem,3.2vw,2.5rem)] font-extrabold leading-tight text-[var(--color-text-primary)]">
          {title}
        </h1>
        {description && (
          <p className="max-w-2xl text-[14px] leading-relaxed text-[var(--color-text-secondary)]">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
